// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { EndInvestorOnboardingOffer } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/EndInvestor';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

const useEndInvestorOnboardingOffers: () => UseQueryResult<
  TemplateContract<EndInvestorOnboardingOffer>[],
  string
> = () =>
  useOperatorBasedQuery('queryEndInvestorOnboardingOffers', (ledgerApi, offset, operator) =>
    ledgerApi.queryEndInvestorOnboardingOffers(offset, operator),
  );

export default useEndInvestorOnboardingOffers;
